import { StringUnionKeyAsValue } from '~commonInfra/utils/TypescriptHelpers';


enum IContentFilterKeyEnum {
  isCertified = 'isCertified',
  discardIdentity = 'discardIdentity',
  backgroundJobStatus = 'backgroundJobStatus',
  backgroundJobTaskType = 'backgroundJobTaskType',
  backgroundJobTimeRange = 'backgroundJobTimeRange',
  collectionVisibility = 'collectionVisibility',
  completedAfter = 'completedAfter',
  completedBefore = 'completedBefore',
  connectionType = 'connectionType',
  containerType = 'containerType',
  createdBefore = 'createdBefore',
  createdAfter = 'createdAfter',
  deletedBefore = 'deletedBefore',
  deletedAfter = 'deletedAfter',
  createdTimeBefore = 'createdTimeBefore',
  createdTimeAfter = 'createdTimeAfter',
  databaseUsername = 'databaseUsername',
  deleter = 'deleter',
  path = 'path',
  domain = 'domain',
  extractStatus = 'extractStatus',
  workbookConnFilter = 'workbookConnFilter',
  failureType = 'failureType',
  favoriteCollectionsFilter = 'favoriteCollectionsFilter',
  flow = 'flow',
  flowOutputStep = 'flowOutputStep',
  hasDatasource = 'hasDatasource',
  hasAlert = 'hasAlert',
  hideEmptyCollections = 'hideEmptyCollections',
  hasExtracts = 'hasExtracts',
  hasPassword = 'hasPassword',
  includeLiveToDataEngine = 'includeLiveToDataEngine',
  inGroup = 'inGroup',
  lastRefreshedBefore = 'lastRefreshedBefore',
  lastRefreshedAfter = 'lastRefreshedAfter',
  location  = 'location',
  maxSiteRole = 'maxSiteRole',
  groupsMinimumSiteRole = 'groupsMinimumSiteRole',
  modifiedBefore = 'modifiedBefore',
  modifiedAfter = 'modifiedAfter',
  updatedTimeBefore = 'updatedTimeBefore',
  updatedTimeAfter = 'updatedTimeAfter',
  owner = 'owner',
  ownerUserName = 'ownerUserName',
  parent = 'parent',
  parentProject = 'parentProject',
  allProjects = 'allProjects',
  project = 'project',
  virtualConnection = 'virtualConnection',
  schedule = 'schedule',
  search = 'search',
  serverName = 'serverName',
  serverPort = 'serverPort',
  showEmbedded = 'showEmbedded',
  showSystemJobs = 'showSystemJobs',
  siteId = 'siteId',
  siteRole = 'siteRole',
  startedAfter = 'startedAfter',
  startedBefore = 'startedBefore',
  status = 'status',
  tag = 'tag',
  taskType = 'taskType',
  workbook = 'workbook',
  datasource = 'datasource',
  favorite = 'favorite',
  recent = 'recent',
  user = 'user',
  group = 'group',
  groupset = 'groupset',
  hasActiveWarning = 'hasActiveWarning',
  hasActiveDataQualityWarning = 'hasActiveDataQualityWarning', // the crass version of 'hasActiveWarning'
  usersPersonalSpaceContent = 'usersPersonalSpaceContent',
  isEmbedded = 'isEmbedded',
  accelerationStatus = 'accelerationStatus',
  isTabID = 'isTabID',
  identityPool = 'identityPool'
}

export type IContentFilters<T> = Record<keyof typeof IContentFilterKeyEnum, T>;
export type IContentFilterKeyNames = keyof typeof IContentFilterKeyEnum;

/**
 * A type-safe way of identifying the filter key names.
 */
export type ContentFilterKeyName = keyof IContentFilters<any>;

/**
 * These are the client-side filter names, which appear in the URL on browse/search pages and correspond
 * with the names of the filters in the filter panel. They are converted to server-side filters in
 * ServerFilterClauses.ts.
 *
 * Despite the type-safe string union type, these values are listed out as variables because it is
 * clearer to identify them semantically in places where we don't type safety (e.g. $location.search).
 */
export const ContentFiltersKeys: StringUnionKeyAsValue<ContentFilterKeyName> = IContentFilterKeyEnum;

// We want this separate from the other filter keys because it behaves differently (should not affect Clear All Filter in Filter Panel,
// for example, and has a default state)
export const ContentTypeFilterKey = 'contentType';
